import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Spinner
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import  MapPicker  from '../../../../helpers/ui/MapPicker'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import Shimmer from "react-shimmer-effect";
// import Lottie from "react-lottie";
// import lottieLoading from "../../../../assets/lotties/launcher.json";

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            loadingDetail: false,
            dataForm: {},
            detailData: {},
            uuid: new URLSearchParams(window.location.search).get('uuid'),
            gagal_txt : ''
        }
    }
    
    loadDetail = async () => {
        await this.updateBloc.fetchDetail({uuid: this.state.uuid })
    }
    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }
    checkData = async () => {
        await this.updateBloc.fetchCheck(this.state.dataForm)
    }
    
    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 
        
        this.setState({
            dataForm: values,
            confirm: true
        })
    }
    
    confirmResponse = (response) => {
        let forState = {}
        this.setState({
            gagal_txt: "Gagal!"
        })
        switch(response) {
            case 'cancel':
        forState = {
            confirm: false
        }
        break;
        case 'confirm':
            forState = {
                loading: true,
                confirm: false
            }
            this.submitData()
            // this.checkData()
            break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
                case 'failed':
                    forState = {
                        failed: false
                    }
                    break;
                    default:       
                }
                this.setState(forState)
            }
                    
        componentDidMount() {
            // const queryParams = new URLSearchParams(window.location.search)
            // console.log(this.state.uuid)
            // this.loadDetail()
            this.updateBloc.detailChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.LOADING:
                        this.setState({
                            loadingDetail : true
                        })
                        break
                    case apiResponse.COMPLETED:
                        if(result.data.status) {
                            let response = result.data.response
                            this.setState({
                                detailData: response,
                                loadingDetail : false
                            })
                        }
                        break
                    case apiResponse.ERROR:
                        this.setState({
                            loadingDetail : false
                        })
                        break
                    default:
                    break
                    }
            })
            this.updateBloc.fetchDetail({uuid: this.state.uuid })
            // this.updateBloc.createChannel.subscribe((result) => {
            //     switch (result.status) {
            //         case apiResponse.COMPLETED:
            //     this.setState({
            //         loading: false,
            //         success: true,
            //     });
            //     break
            //     case apiResponse.ERROR:
            //         this.setState({
            //             gagal_txt: "Gagal!",
            //             loading: false,
            //             failed: true,
            //         });
            //         break
            //     default:
            //     break
            //     }
            // })
            // this.updateBloc.checkChannel.subscribe((result) => {
            //     switch (result.status) {
            //         case apiResponse.COMPLETED:
            //             console.log(result.data.response)
            //             // this.setState({
            //             //     loading: false,
            //             //     success: true,
            //             // });
            //             if(result.data.response==0){
            //                 this.submitData()
            //             }else{
            //                 this.setState({
            //                     gagal_txt: "Tanggal Hari Libur Sudah ada",
            //                     loading: false,
            //                     failed: true,
            //                 });
            //             }
            //             break
            //         case apiResponse.ERROR:
            //             this.setState({
            //                 gagal_txt: "Gagal!",
            //                 loading: false,
            //                 failed: true,
            //             });
            //             break
            //         default:
            //             break
            //     }
            // })
       
        }

        componentWillUnmount() {
            this.updateBloc.detailChannel.unsubscribe()
        }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Detail Data Lokasi Absen Mobile</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Detail data Lokasi Absen Mobile 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Lokasi
                                            </label>
                                            <Col md="3">
                                                {this.state.loadingDetail ?
                                                <Shimmer>
                                                    <div
                                                        style={{
                                                        width: "100%",       // full width seperti AvField
                                                        height: "38px",      // tinggi sama dengan form-control default Bootstrap
                                                        borderRadius: "0.25rem",
                                                        }}
                                                        className="mb-2"
                                                    ></div>
                                                </Shimmer>
                                                :
                                                <>
                                                <AvField
                                                type="hidden"
                                                name="presensi_location_uuid"
                                                value={this.state.detailData?.presensi_location_uuid || ""
                                                }
                                                />
                                                <p className="form-control-plaintext">
                                                    {this.state.detailData?.presensi_location_name || "-"}
                                                </p>
                                                </>
                                                }
                                            </Col>
                                        </Row>
                                        
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Toleransi Radius
                                            <br/>
                                            (dalam meter)
                                            </label>
                                            <Col md="3">
                                            {this.state.loadingDetail ?
                                                <Shimmer>
                                                    <div
                                                        style={{
                                                        width: "100%",       // full width seperti AvField
                                                        height: "38px",      // tinggi sama dengan form-control default Bootstrap
                                                        borderRadius: "0.25rem",
                                                        }}
                                                        className="mb-2"
                                                    ></div>
                                                </Shimmer>
                                                :
                                                <>
                                                <p className="form-control-plaintext">
                                                    {this.state.detailData?.presensi_location_radius_meters || "-"}
                                                </p>
                                                </>
                                            }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Latitude
                                            </label>
                                            <Col md="3">
                                            {this.state.loadingDetail ?
                                                <Shimmer>
                                                    <div
                                                        style={{
                                                        width: "100%",       // full width seperti AvField
                                                        height: "38px",      // tinggi sama dengan form-control default Bootstrap
                                                        borderRadius: "0.25rem",
                                                        }}
                                                        className="mb-2"
                                                    ></div>
                                                </Shimmer>
                                                :
                                                <>
                                                <p className="form-control-plaintext">
                                                    {this.state.detailData?.presensi_location_latitude || "-"}
                                                </p>
                                                </>
                                            }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Longitude
                                            </label>
                                            <Col md="3">
                                            {this.state.loadingDetail ?
                                                <Shimmer>
                                                    <div
                                                        style={{
                                                        width: "100%",       // full width seperti AvField
                                                        height: "38px",      // tinggi sama dengan form-control default Bootstrap
                                                        borderRadius: "0.25rem",
                                                        }}
                                                        className="mb-2"
                                                    ></div>
                                                </Shimmer>
                                                :
                                                <>
                                                <p className="form-control-plaintext">
                                                    {this.state.detailData?.presensi_location_longitude || "-"}
                                                </p>
                                                </>
                                            }
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label htmlFor="fieldTitle" className="col-md-3 col-form-label">
                                                Titik GPS
                                            </label>
                                            <Col md="8">
                                            {this.state.loadingDetail ? (
                                            // === Loading State ===
                                            <div
                                                style={{
                                                // textAlign: "center",
                                                padding: "80px 0",
                                                display: "flex",
                                                flexDirection: "column",
                                                // alignItems: "center",
                                                // justifyContent: "center",
                                                }}
                                            >
                                                <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
                                                <h5 className="mt-4 text-muted">Memeriksa data...</h5>
                                            </div>
                                            ) : (
                                            // === Normal State (saat data sudah siap) ===
                                            <>
                                                <MapPicker
                                                 mode="view"
                                                onLocationSelect={this.handleLocationSelect}
                                                defaultPolygon={this.state.detailData?.presensi_geolocation ?? []}
                                                // defaultPolygon
                                                // defaultPosition={[
                                                //     parseFloat(this.state.detailData?.presensi_geolocation || -6.914744),
                                                //     parseFloat(this.state.detailData?.presensi_geolocation || 107.60981),
                                                // ]}
                                                />

                                            </>
                                            )}
                                            </Col>      
                                            </Row>

                                            {this.state.location && (
                                            <Row className="mb-3">
                                                <Col md={{ span: 6, offset: 3 }}>
                                                <div className="p-2 bg-light border rounded">
                                                    <strong>Latitude:</strong> {this.state.location.lat} <br />
                                                    <strong>Longitude:</strong> {this.state.location.lng}
                                                </div>
                                                </Col>
                                            </Row>
                                            )}
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/presensi_lokasi.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                               
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/presensi_lokasi.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView